import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

export function useAppointmentPractitionerRows(appointmentId: string | null | undefined) {
  return useQuery({
    queryKey: ['appointment-practitioners', appointmentId ?? null],
    enabled: Boolean(appointmentId),
    queryFn: async () => {
      if (!appointmentId) return [];
      const { data, error } = await supabase
        .from('appointment_practitioners')
        .select('practitioner_id, is_primary')
        .eq('appointment_id', appointmentId);
      if (error) throw error;
      return data ?? [];
    },
  });
}
